import { createReducer } from "@reduxjs/toolkit";
import {
	API_GET_ALL_CAMPAIGNS,
	API_GET_ALL_CAMPAIGNS_FAIL,
	API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN,
	API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_FAIL,
	API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_SUCCESS,
	API_GET_CAMPAIGN_RESULT_QR_CODE,
	API_GET_CAMPAIGN_RESULT_QR_CODE_SUCCESS,
	API_GET_CAMPAIGN_RESULT_QR_CODE_FAIL,
	API_GET_CAMPAIGNS_RECORDS_PAGE_SUCCESS,
	API_SEARCH_CAMPAIGN_RESULTS,
	API_SEARCH_CAMPAIGN_RESULTS_SUCCESS,
	API_SEARCH_CAMPAIGN_RESULTS_FAIL,
	SET_QR_SEARCH_CAMPAIGN,
} from "actions/campaign";

import { errorHandler, ErrorAction } from "utils/error";
import { getVersion } from "services/campaign";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const adaptCampaignResponse = (campaign, currentClient) => {
	try {
		if (!campaign || currentClient !== V2_CLIENT) {
			return campaign;
		}

		const adapted = { ...campaign };

		const fieldMap = {
			limitedCenters: 'limitedCenters',
			templateEmail: 'templateEmail',
			createdAt: 'created_at',
			updatedAt: 'updated_at',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.analysesPack && typeof adapted.analysesPack === 'object' && adapted.analysesPack.id !== undefined) {
			if (adapted.analyses_pack_id === undefined) {
				adapted.analyses_pack_id = adapted.analysesPack.id;
			}
		}

		if (adapted.prescriber && typeof adapted.prescriber === 'object' && adapted.prescriber.id !== undefined) {
			if (adapted.prescriber_id === undefined) {
				adapted.prescriber_id = adapted.prescriber.id;
			}
		}

		if (adapted.billingCompany && typeof adapted.billingCompany === 'object' && adapted.billingCompany.id !== undefined) {
			if (adapted.billing_company_id === undefined) {
				adapted.billing_company_id = adapted.billingCompany.id;
			}
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptCampaignResponse:', error);
		return campaign;
	}
};

export const adaptCampaignPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptCampaignResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptCampaignResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptCampaignPayloadResponse:', error);
		return action.payload || {};
	}
};

const initialState = {
	list: {
		data: [],
		loading: false,
	},
	focus: null,
	loading: false,
	recordsCount: 0,
	current: null,
	campaignQR: null,
};

const campaigns = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_CAMPAIGNS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_CAMPAIGNS_FAIL]: (state, action) => {
		errorHandler("Campagnes", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN]: (state, action) => {
		state.loading = true;
	},
	[API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_FAIL]: (state, action) => {
		errorHandler("Patient des campagnes", ErrorAction.READ, action.error);
		state.loading = false;
	},

	[API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_GET_CAMPAIGNS_RECORDS_TO_ASSIGN);
		state.recordsCount = adaptedPayload.data || 0;
		state.loading = false;
	},
	[API_GET_CAMPAIGN_RESULT_QR_CODE]: (state, action) => {
		state.loading = true;
		state.current = null;
	},
	[API_GET_CAMPAIGN_RESULT_QR_CODE_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_GET_CAMPAIGN_RESULT_QR_CODE);
		if (adaptedPayload.data && adaptedPayload.data.message) {
			state.current = { message: adaptedPayload.data.message };
		} else {
			state.current = adaptedPayload.data || null;
		}
		state.loading = false;
	},
	[API_GET_CAMPAIGN_RESULT_QR_CODE_FAIL]: (state, action) => {
		errorHandler("QR code", ErrorAction.READ, action.error);
		state.loading = false;
		state.current = null;
	},
	[API_SEARCH_CAMPAIGN_RESULTS]: (state, action) => {
		state.list = { data: [], loading: true };
	},
	[API_SEARCH_CAMPAIGN_RESULTS_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_SEARCH_CAMPAIGN_RESULTS);
		state.list = { data: adaptedPayload.data || [], loading: false };
	},
	[API_SEARCH_CAMPAIGN_RESULTS_FAIL]: (state, action) => {
		state.list = { data: [], loading: false };
		errorHandler("Recherche QR code", ErrorAction.READ, action.error);
	},

	[SET_QR_SEARCH_CAMPAIGN]: (state, action) => {
		state.campaignQR = action.data;
	},
});

export default campaigns;
